import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import Dropdown, { DropdownContent, DropdownTrigger } from 'react-simple-dropdown';

import getActiveMatches from '../../../../../selectors/seatingchart/guestRailSelector';

import FilterItem from './FilterItem';

import './Filter.styles.less';

const ORDERED_FACETS = ['seated', 'rsvp'];
const FACET_BUCKETS = {
  seated: { key: 'seated', name: 'Seated' },
  notSeated: { key: 'notSeated', name: 'Not Seated' },
  attending: { key: 'attending', name: 'Attending' },
  undecided: { key: 'undecided', name: 'No Response' },
  declined: { key: 'declined', name: 'Not Attending' }
};

const Filter = ({
  activeFacetElements,
  activeMatches,
  className,
  filterState,
  facets,
  onToggleFacet,
  onToggleFilter,
  noGuests,
  onResetFacets,
  facetMatches,
}) => {
  const filtersCount = activeFacetElements.length;

  return (
    <div className={cx('sc__filter', className)}>
      <Dropdown active={filterState}>
        <DropdownTrigger onClick={onToggleFilter}>
          <button className="sc__filter__toggle-button">
            <i className="zolaicon zolaicon-filter" />
            Filter
            {!filterState && filtersCount > 0 && (
              <div className="sc__filter__count">
                <span className="sc__filter__count__label">{filtersCount}</span>
              </div>
            )}
          </button>
          {filterState && <button className="sc__filter__close-button"><i className="zolaicon zolaicon-close" /></button>}
        </DropdownTrigger>
        <DropdownContent>
          {filterState && (
            <div className="sc__filter__facets">
              {facets != null && ORDERED_FACETS.map((key) => {
                const facet = facets[key];
                const { elements, label } = facet;
                return (
                  <div key={label} className="sc__filter__facet">
                    <div className="sc__filter__label">{label}</div>
                    <ul className="list-unstyled sc__filter__list">
                      {elements.length > 0 && elements.map((element) => {
                        const { name } = FACET_BUCKETS[element];
                        return (
                          <FilterItem
                            key={name}
                            activeFacetElements={activeFacetElements}
                            activeMatches={activeMatches}
                            checked={activeFacetElements.indexOf(element) > -1}
                            element={element}
                            facetMatches={facetMatches}
                            label={facet.label}
                            name={name}
                            onChange={() => onToggleFacet(element)}
                          />
                        );
                      })}
                    </ul>
                  </div>
                );
              })}
            </div>
          )}
        </DropdownContent>
      </Dropdown>
      {noGuests && filterState && (
        <div className="sc__no-filter-results">
          <h3 className="sc__no-filter-results__header">Hm… we couldn’t find a match.</h3>
          <p className="sc__no-filter-results__text">Make sure you’ve entered the correct name, or click below to add a new guest.</p>
          <button onClick={onResetFacets} className="sc__no-filter-results__clear-button">Clear Filters</button>
        </div>
      )}
    </div>
  );
};

Filter.propTypes = {
  activeMatches: PropTypes.arrayOf(PropTypes.oneOfType(
    [PropTypes.number, PropTypes.string]
  )),
  activeFacetElements: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  filterState: PropTypes.bool,
  facets: PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
    elements: PropTypes.arrayOf(PropTypes.string)
  }),
  onToggleFacet: PropTypes.func.isRequired,
  onToggleFilter: PropTypes.func.isRequired,
  onResetFacets: PropTypes.func,
  noGuests: PropTypes.bool,
  facetMatches: PropTypes.shape({
    seated: PropTypes.arrayOf(PropTypes.oneOfType(
      [PropTypes.number, PropTypes.string]
    )),
    notSeated: PropTypes.arrayOf(PropTypes.oneOfType(
      [PropTypes.number, PropTypes.string]
    )),
    attending: PropTypes.arrayOf(PropTypes.oneOfType(
      [PropTypes.number, PropTypes.string]
    )),
    undecided: PropTypes.arrayOf(PropTypes.oneOfType(
      [PropTypes.number, PropTypes.string]
    )),
    declined: PropTypes.arrayOf(PropTypes.oneOfType(
      [PropTypes.number, PropTypes.string]
    )),
  }),
};

const mapStateToProps = state => ({
  activeMatches: getActiveMatches(state.guestRail),
  facets: state.guestRail.facets,
  facetMatches: state.guestRail.facetMatches,
});

export default connect(mapStateToProps)(Filter);



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/GuestList/Filter/Filter.jsx